function cov_1lu1rsgtpd() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronDown.tsx";
  var hash = "70ab844cf3ee04b49a54a20701a1141c5bc163a3";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronDown.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 52
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "70ab844cf3ee04b49a54a20701a1141c5bc163a3"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1lu1rsgtpd = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1lu1rsgtpd();
var Icon = (cov_1lu1rsgtpd().s[0]++, {
  name: 'chevron-down',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.7808 7.0239C19.3199 7.45516 19.4073 8.24178 18.976 8.78085L12.976 16.2809C12.7388 16.5774 12.3797 16.75 12 16.75C11.6202 16.75 11.2611 16.5774 11.0239 16.2809L5.02387 8.78085C4.59261 8.24178 4.68001 7.45516 5.21909 7.0239C5.75816 6.59264 6.54478 6.68004 6.97604 7.21912L12 13.499L17.0239 7.21912C17.4551 6.68004 18.2417 6.59264 18.7808 7.0239Z\" fill=\"currentColor\"/>"
});
export default Icon;